<script setup lang="ts">
import { useCurrentUser } from '@/composables/useCurrentUser'
import { ref } from 'vue'

const { isAdmin, hasSystemPermission } = useCurrentUser()
const isOpen = ref(false)

const adminItems = [
  {
    title: 'Статистика',
    icon: 'tabler-chart-bar',
    to: '/admin-overview',
  },
  {
    title: 'Активация',
    icon: 'tabler-filter',
    to: '/admin-analytics',
  },
  {
    title: 'Организации',
    icon: 'tabler-building',
    to: '/admin-organizations',
  },
  {
    title: 'Пользователи',
    icon: 'tabler-users-group',
    to: '/all-users',
  },
  {
    title: 'Документы',
    icon: 'tabler-file-description',
    to: '/legal',
  },
  {
    title: 'Управление тарифами',
    icon: 'tabler-credit-card',
    to: '/admin-tariffs',
  },
  {
    title: 'Опросник',
    icon: 'tabler-clipboard-list',
    to: '/admin-panel',
  },
  ...(hasSystemPermission('support.view') ? [{
    title: 'Поддержка',
    icon: 'tabler-headset',
    to: '/support-admin',
  }] : []),
  ...(hasSystemPermission('system.roles.manage') ? [{
    title: 'Сотрудники системы',
    icon: 'tabler-user-cog',
    to: '/system-employees',
  }] : []),
]
</script>

<template>
  <div v-if="isAdmin">
    <VBtn
      variant="tonal"
      color="primary"
      size="small"
      prepend-icon="tabler-shield-lock"
      :append-icon="isOpen ? 'tabler-chevron-up' : 'tabler-chevron-down'"
    >
      <span class="d-none d-md-inline">Админ панель</span>
      <VMenu
        v-model="isOpen"
        activator="parent"
        location="bottom end"
        offset="8px"
        :close-on-content-click="true"
      >
        <VList density="compact" min-width="220">
          <VListItem
            v-for="item in adminItems"
            :key="item.to"
            :to="item.to"
          >
            <template #prepend>
              <VIcon :icon="item.icon" size="20" class="me-2" />
            </template>
            <VListItemTitle>{{ item.title }}</VListItemTitle>
          </VListItem>
        </VList>
      </VMenu>
    </VBtn>
  </div>
</template>
